import {
    companyHeadline,
    contactHeadline,
    percentageGroup, policyHeadline,
} from "../../utils/step.fields.utils";
import schema_public_liability from "../form/schema.public_liability";


const step_schema_public_liability = [
    // business
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'company_name',
        required: false
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'company_year'
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'company_turnover',
        orderOptions: false
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'occupation_0_type',
        headline: companyHeadline,
        label: "What is your trade / business?"
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'postcode',
        headline: companyHeadline,
        label: 'What is your trading postcode?'
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'address1',
        skip_question: true,
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'address2',
        skip_question: true,
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'address3',
        skip_question: true,
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'address4',
        skip_question: true,
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_BUSINESS,
        key: 'city',
        skip_question: true,
    },
    // contact
    {
        percentage_group: percentageGroup.PERCENTAGE_CONTACT,
        headline: contactHeadline,
        key: 'driver_details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_CONTACT,
        headline: contactHeadline,
        key: 'telephone'
    },
    {
        percentage_group: percentageGroup.PERCENTAGE_CONTACT,
        headline: contactHeadline,
        key: 'email'
    },

    // policy
    {
        key: 'cover_date'
    },
    {
        ...schema_public_liability.cover_level,
        key: 'cover_level',
        headline: policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'has_employees',
        children: [
            {
                key: 'requires_employees_liability_cover',
                required_if: parent_value => parent_value
            },
        ],
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_public_liability;
